module.exports = __webpack_public_path__ + "img/user2.9d4c1083.jpg";